import { NgModule } from '@angular/core';
import { EdDatepickerComponent } from './components/forms/ed-datepicker/ed-datepicker.component';
import { EdInputFileComponent } from './components/forms/ed-input-file/ed-input-file.component';
import { ChartCardComponent } from './components/chart-card/chart-card.component';
import { KpiCardComponent } from './components/kpi-card/kpi-card.component';
import { GeoMapCardComponent } from './components/geo-map-card/geo-map-card.component';
import { GenericCardComponent } from './components/generic-card/generic-card.component';
import { MapComponent } from './components/map/map.component';
import { TableCardComponent } from './components/table-card/table-card.component';
import { HeaderComponent } from './components/header/header.component';
import { EdTableComponent } from './components/ed-table/ed-table.component';
import { EdModalConfirmComponent } from './components/modals/ed-modal-confirm/ed-modal-confirm.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { SkeletonListComponent } from './components/skeleton-list/skeleton-list.component';
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';
import { ComponentsModule } from '@ed---interne/ng-uui-components';

const componentsList = [
    SkeletonListComponent,
    GenericCardComponent,
    EdDatepickerComponent,
    EdInputFileComponent,
    GenericCardComponent,
    KpiCardComponent,
    GeoMapCardComponent,
    ChartCardComponent,
    MapComponent,
    TableCardComponent,
    EdTableComponent,
    HeaderComponent,
    EdModalConfirmComponent,
    SidenavComponent,
    InfiniteScrollDirective,
];
@NgModule({
    imports: componentsList,
    exports: componentsList,
})
export class SharedModule {}
